import html2canvas from 'html2canvas';

/**
 * 把预览 iframe 的文档 body 截成一张 JPEG data URL，供签字服务转存。
 * 签字服务的 /api/media 限 3MB，从高清逐级降档直到装得下。
 */
export async function captureDocumentImage(source: HTMLElement): Promise<string> {
  const LIMIT = 3 * 1024 * 1024;
  const ladders: Array<{ scale: number; quality: number }> = [
    { scale: 1.5, quality: 0.85 },
    { scale: 1.2, quality: 0.75 },
    { scale: 1.0, quality: 0.6 },
  ];
  let last = '';
  for (const { scale, quality } of ladders) {
    const canvas = await html2canvas(source, {
      backgroundColor: '#ffffff',
      scale,
      useCORS: true,
      logging: false,
      windowWidth: source.scrollWidth,
      windowHeight: source.scrollHeight,
    });
    last = canvas.toDataURL('image/jpeg', quality);
    // dataURL 长度 ≈ 字节数 × 4/3
    if (last.length * 0.75 <= LIMIT) return last;
  }
  if (last.length * 0.75 > LIMIT) {
    throw new Error('文档过长，生成的图片超过 3MB，请缩短文档或分次签署');
  }
  return last;
}
